export * as ColorTokens from './colors';
export * as FontTokens from './fonts';
export * as SizeTokens from './sizes';
export * as EffectTokens from './effect';
